/* ==========================================================================
   Wunderfahrrad – Probefahrt-Buchung (eigenes Popup, ersetzt Tipo)
   Datei: assets/wf-probefahrt.js
   - Eigener Button unter "In den Warenkorb", übernimmt Marke/Modell/Bild
     von der Produktseite. Erscheint nur bei E-Bikes, nicht bei Zubehör
     (Akkus, Schlösser, Taschen …) oder sonstigen Nicht-Fahrrädern.
   - Datum: die nächsten WF_BOOKING.daysAhead Tage (ohne Sonntag),
     Uhrzeit: 30-Minuten-Slots innerhalb der Öffnungszeiten.
   - Sendet die Anfrage als JSON an den n8n-Webhook (WF_BOOKING.webhook).
   - Feuert bei Erfolg Tracking-Events (Meta Pixel, GA4/dataLayer).
   ========================================================================== */
(function () {
  'use strict';

  var WF_BOOKING = {
    webhook: 'https://wunderfahrrad.app.n8n.cloud/webhook/probefahrt',
    daysAhead: 20,
    slotMinutes: 30,
    // Öffnungszeiten je Wochentag (0 = So, 1 = Mo … 6 = Sa); null = geschlossen
    hours: {
      0: null,
      1: { from: '09:00', to: '17:00' },
      2: { from: '09:00', to: '17:00' },
      3: { from: '09:00', to: '17:00' },
      4: { from: '09:00', to: '17:00' },
      5: { from: '09:00', to: '17:00' },
      6: { from: '09:00', to: '13:00' }
    },
    address: 'Lückstraße 47, 10317 Berlin'
  };

  var DAY_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var DAY_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmtDate(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function isoDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

  function productInfo() {
    var info = { title: '', vendor: '', handle: '', url: location.href.split('?')[0], image: '', variant: '' };
    try {
      var json = document.querySelector('[id^="product_json_"]');
      if (json) {
        var p = JSON.parse(json.textContent);
        info.title = p.title || '';
        info.vendor = p.vendor || '';
        info.handle = p.handle || '';
      }
    } catch (e) {}
    if (!info.title) {
      var h = document.querySelector('.single_product__title');
      info.title = h ? h.textContent.trim() : document.title;
    }
    var img = document.querySelector('.gallery_big .swiper-slide img');
    if (img) info.image = (img.currentSrc || img.src || '').replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?\./i, '_400x.');
    var sel = document.querySelector('.single_product__info select');
    if (sel && sel.value) info.variant = sel.value;
    // Marke aus dem Titel (Shopify-"vendor" ist bei uns nur "wunderfahrrad")
    var brands = ['Himiway', 'ADO', 'Bulls', 'Cube', 'Fiido', 'Engwe', 'Tenways', 'Kalkhoff', 'Gazelle', 'Haibike', 'Riese & Müller', 'Cowboy', 'VanMoof', 'Fischer', 'Prophete', 'Zündapp', 'Telefunken', 'Kettler', 'Winora', 'Victoria', 'Pegasus', 'Bergamont', 'Focus', 'Ghost', 'Scott', 'Trek', 'Giant', 'Specialized', 'Orbea', 'KTM', 'Stevens', 'Raleigh', 'Diamant', 'Hercules', 'Flyer', 'Moustache', 'Cannondale', 'Brompton', 'Eskute', 'Dyu', 'Legend', 'Urtopia'];
    var lower = info.title.toLowerCase();
    for (var i = 0; i < brands.length; i++) {
      if (lower.indexOf(brands[i].toLowerCase()) !== -1) { info.brand = brands[i]; break; }
    }
    if (!info.brand) info.brand = '';
    return info;
  }

  function buildDays() {
    var days = [];
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1); // ab morgen
    var guard = 0;
    while (days.length < WF_BOOKING.daysAhead && guard < 60) {
      if (WF_BOOKING.hours[d.getDay()]) days.push(new Date(d));
      d.setDate(d.getDate() + 1);
      guard++;
    }
    return days;
  }

  function buildSlots(date) {
    var h = WF_BOOKING.hours[date.getDay()];
    if (!h) return [];
    var slots = [];
    var from = h.from.split(':'), to = h.to.split(':');
    var t = parseInt(from[0], 10) * 60 + parseInt(from[1], 10);
    var end = parseInt(to[0], 10) * 60 + parseInt(to[1], 10);
    while (t + WF_BOOKING.slotMinutes <= end) {
      slots.push(pad(Math.floor(t / 60)) + ':' + pad(t % 60));
      t += WF_BOOKING.slotMinutes;
    }
    return slots;
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }

  function track(data) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Schedule', { content_name: data.product, content_category: 'Probefahrt' });
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'probefahrt_gebucht', product: data.product, datum: data.date, uhrzeit: data.time });
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'probefahrt_gebucht', { product: data.product, datum: data.date, uhrzeit: data.time });
      }
    } catch (e) {}
  }

  var modal, state = { date: null, time: null };

  function openModal() {
    if (!modal) createModal();
    document.body.classList.add('wf-modal-open');
    modal.classList.add('is-open');
    var first = modal.querySelector('.wf-day');
    if (first && !state.date) first.click();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('wf-modal-open');
  }

  function createModal() {
    var info = productInfo();
    modal = el('div', 'wf-modal');
    modal.innerHTML =
      '<div class="wf-modal__backdrop"></div>' +
      '<div class="wf-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="wf-modal-title">' +
        '<button type="button" class="wf-modal__close" aria-label="Schließen">&times;</button>' +
        '<div class="wf-modal__head">' +
          (info.image ? '<img class="wf-modal__img" src="' + info.image + '" alt="">' : '') +
          '<div>' +
            '<div class="wf-modal__eyebrow">Probefahrt in Berlin</div>' +
            '<h3 id="wf-modal-title" class="wf-modal__title">' + info.title + '</h3>' +
            '<div class="wf-modal__addr">' + WF_BOOKING.address + '</div>' +
          '</div>' +
        '</div>' +
        '<form class="wf-modal__form" novalidate>' +
          '<div class="wf-field"><label>Datum</label><div class="wf-days"></div></div>' +
          '<div class="wf-field"><label>Uhrzeit <span class="wf-muted">(30 Minuten)</span></label><div class="wf-slots"></div></div>' +
          '<div class="wf-grid">' +
            '<div class="wf-field"><label for="wf-vorname">Vorname</label><input id="wf-vorname" name="vorname" type="text" autocomplete="given-name" required></div>' +
            '<div class="wf-field"><label for="wf-nachname">Nachname</label><input id="wf-nachname" name="nachname" type="text" autocomplete="family-name" required></div>' +
            '<div class="wf-field"><label for="wf-telefon">Telefonnummer</label><input id="wf-telefon" name="telefon" type="tel" autocomplete="tel" required></div>' +
            '<div class="wf-field"><label for="wf-email">E-Mail</label><input id="wf-email" name="email" type="email" autocomplete="email" required></div>' +
          '</div>' +
          '<input type="text" name="wf_hp" class="wf-hp" tabindex="-1" autocomplete="off">' +
          '<div class="wf-error" hidden></div>' +
          '<button type="submit" class="wf-submit">Probefahrt buchen</button>' +
          '<p class="wf-legal">Mit dem Absenden stimmen Sie zu, dass wir Ihre Angaben zur Terminvereinbarung verwenden. Sie erhalten eine Bestätigung per E-Mail.</p>' +
        '</form>' +
        '<div class="wf-success" hidden>' +
          '<div class="wf-success__icon">✓</div>' +
          '<h3>Vielen Dank!</h3>' +
          '<p class="wf-success__text"></p>' +
          '<p>Eine Bestätigung ist unterwegs an Ihre E-Mail-Adresse. Wir freuen uns auf Sie in der ' + WF_BOOKING.address + '.</p>' +
          '<button type="button" class="wf-submit wf-success__close">Schließen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    var daysWrap = modal.querySelector('.wf-days');
    var slotsWrap = modal.querySelector('.wf-slots');
    buildDays().forEach(function (d) {
      var b = el('button', 'wf-day', '<span>' + DAY_SHORT[d.getDay()] + '</span><strong>' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.</strong>');
      b.type = 'button';
      b.addEventListener('click', function () {
        state.date = d; state.time = null;
        daysWrap.querySelectorAll('.wf-day').forEach(function (x) { x.classList.toggle('active', x === b); });
        slotsWrap.innerHTML = '';
        buildSlots(d).forEach(function (t) {
          var s = el('button', 'wf-slot', t);
          s.type = 'button';
          s.addEventListener('click', function () {
            state.time = t;
            slotsWrap.querySelectorAll('.wf-slot').forEach(function (x) { x.classList.toggle('active', x === s); });
          });
          slotsWrap.appendChild(s);
        });
      });
      daysWrap.appendChild(b);
    });

    modal.querySelector('.wf-modal__backdrop').addEventListener('click', closeModal);
    modal.querySelector('.wf-modal__close').addEventListener('click', closeModal);
    modal.querySelector('.wf-success__close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    var form = modal.querySelector('.wf-modal__form');
    var errBox = modal.querySelector('.wf-error');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errBox.hidden = true;
      var f = form.elements;
      var missing = [];
      if (!state.date) missing.push('Datum');
      if (!state.time) missing.push('Uhrzeit');
      if (!f.vorname.value.trim()) missing.push('Vorname');
      if (!f.nachname.value.trim()) missing.push('Nachname');
      if (!f.telefon.value.trim()) missing.push('Telefonnummer');
      if (!f.email.value.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.value.trim())) missing.push('gültige E-Mail');
      if (missing.length) {
        errBox.textContent = 'Bitte ergänzen: ' + missing.join(', ') + '.';
        errBox.hidden = false;
        return;
      }
      if (f.wf_hp.value) { f.wf_hp.value = ''; }
      var payload = {
        product: info.title,
        brand: info.brand,
        vendor: info.vendor,
        variant: info.variant,
        productUrl: info.url,
        productImage: info.image,
        date: isoDate(state.date),
        dateLabel: DAY_LONG[state.date.getDay()] + ', ' + fmtDate(state.date),
        time: state.time,
        vorname: f.vorname.value.trim(),
        nachname: f.nachname.value.trim(),
        telefon: f.telefon.value.trim(),
        email: f.email.value.trim(),
        page: location.href,
        submittedAt: new Date().toISOString()
      };

      var btn = form.querySelector('.wf-submit');
      btn.disabled = true; btn.textContent = 'Wird gesendet …';

      fetch(WF_BOOKING.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        form.hidden = true;
        var s = modal.querySelector('.wf-success');
        s.querySelector('.wf-success__text').textContent =
          'Ihre Probefahrt „' + info.title + '“ ist reserviert: ' + payload.dateLabel + ' um ' + payload.time + ' Uhr.';
        s.hidden = false;
        track(payload);
      }).catch(function () {
        errBox.textContent = 'Leider hat das Senden nicht geklappt. Bitte versuchen Sie es erneut oder rufen Sie uns an.';
        errBox.hidden = false;
        btn.disabled = false; btn.textContent = 'Probefahrt buchen';
      });
    });
  }

  // Nur E-Bikes bekommen den Probefahrt-Button. Zubehör (Produkttyp "Zubehör"
  // oder Tags wie "Zubehör Himiway") und sonstige Nicht-Fahrräder nicht.
  // Produktdaten kommen aus Shopifys /products/<handle>.js (type + tags).
  var productCheck = null;
  function isBikeProduct() {
    if (productCheck) return productCheck;
    var handle = (location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
    if (!handle) { productCheck = Promise.resolve(false); return productCheck; }
    productCheck = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var type = String(p.type || '').toLowerCase();
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
        var isAccessory = type.indexOf('zubehör') !== -1 || type.indexOf('zubehor') !== -1 ||
          tags.some(function (t) { return t.indexOf('zubehör') === 0 || t.indexOf('zubehor') === 0; });
        if (isAccessory) return false;
        var bikeBrands = ['ado', 'himiway', 'urtopia', 'kemoway'];
        return /e-?bike|fahrr(a|ä)d/.test(type) ||
          tags.some(function (t) { return /e-?bike|fahrr(a|ä)der/.test(t) || bikeBrands.indexOf(t) !== -1; });
      })
      .catch(function () { return false; }); // im Zweifel: kein Button
    return productCheck;
  }

  // Eigener Button direkt unter "In den Warenkorb" (unabhängig von Tipo –
  // die App kann deinstalliert werden, der Tipo-Button wird per CSS versteckt)
  function addButton() {
    if (document.querySelector('.wf-probefahrt-btn')) return;
    var addToCart = document.querySelector('.button_block button[name="add"]');
    if (!addToCart) return;
    isBikeProduct().then(function (ok) {
      if (!ok || document.querySelector('.wf-probefahrt-btn')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wf-probefahrt-btn';
      btn.textContent = 'Probefahrt in Berlin buchen';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
      addToCart.insertAdjacentElement('afterend', btn);
      var hint = document.createElement('p');
      hint.className = 'wf-probefahrt-hint';
      hint.textContent = 'Dieses E-Bike vor Ort testen & persönlich beraten lassen';
      btn.insertAdjacentElement('afterend', hint);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addButton);
  } else {
    addButton();
  }
  [500, 1500, 3000, 6000].forEach(function (ms) { setTimeout(addButton, ms); });
})();